module.exports = __webpack_public_path__ + "static/img/background.7c1a9f6c.svg";